import { Component, OnInit } from '@angular/core';
import { Organization } from 'src/app/models';
import { OrganizationService } from 'src/app/services';
import { AuthorizationService } from 'src/app/services/authorization.service';
import { MemberRoleEnum } from 'src/enumerators';


@Component({
  selector: 'app-sidebar-catalog',
  templateUrl: './sidebar-catalog.component.html',
  styleUrls: ['./sidebar-catalog.component.css']
})
export class SidebarCatalogComponent implements OnInit {
  toggleOpen: boolean = false;
  memberRoleEnum = MemberRoleEnum;
  org: Organization;

  constructor(
    private _organizationService: OrganizationService,
    public authorizationService: AuthorizationService,
    ) { }

  ngOnInit(): void {
    if(!this._organizationService.organization){
      this._organizationService.getCurrentOrg(false).subscribe(
        (res: Organization) => this.org = res,
      )
    } else {
      this.org = this._organizationService.organization;
    }
  }

  checkExact() {
    const url = window.location.href;
    if (url.includes('/catalog/')) {
      return false;
    }else{
      return true;
    }
  }
}
